import React from 'react';
import ContactInfo from './ContactInfo';
import { ContactDetail } from '../../../src/types/ContactDetail';
import { BadgePoundSterling } from 'lucide-react';

interface FooterProps { contactData: ContactDetail[]; copyrightText: string; vatNumber: string; }

const Footer: React.FC<FooterProps> = ({ contactData, copyrightText, vatNumber }) => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-6 py-16">
        <ContactInfo contactData={contactData} titleColorClass="text-white" />
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm text-gray-400"><p>&copy; {new Date().getFullYear()} {copyrightText}</p></div>
        {vatNumber && (
            <div className="flex items-center justify-center space-x-1.5 text-gray-400">
              <BadgePoundSterling className="w-4 h-4 text-green-400" />
              <p>VAT ID:</p>
              <p>{vatNumber}</p>
            </div>
          )}
      </div>
    </footer>
  );
};

export default Footer;
